//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    SIM_PROVIDER_ACCOUNT_DELETE_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    simProviderAccountsDeleteResult,
} from 'Redux/actions';

function* deleteSimProviderAccount({ payload }) {
    try {
        let QUERY = `
            mutation deleteSimProviderAccount ($id: Int!) {
                result: deleteSimProviderAccount (id: $id)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(simProviderAccountsDeleteResult({ delete: data?.result }))
        } else yield put(simProviderAccountsDeleteResult({ error: 'error-sim-provider-account' }))

    } catch (exc) {
        yield put(simProviderAccountsDeleteResult({ error: exc.error }))
        ExceptionManager(exc, 'Modules/simProviderAccounts/views/.components/deleteSimProviderAccount/redux/saga', 'deleteSimProviderAccount');
    }
}

function* watchSimProvidersDeleteRequests() {
    yield takeEvery(SIM_PROVIDER_ACCOUNT_DELETE_REQUEST, deleteSimProviderAccount);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchSimProvidersDeleteRequests)
    ]);
}